import reactComponentLoader from 'scripts/react-component-loader'

import ScrollToTop from './ScrollToTop'

reactComponentLoader(ScrollToTop, '[data-scroll-to-top]')
